import script from "./production-plan-orders.vue?vue&type=script&setup=true&lang=js"
export * from "./production-plan-orders.vue?vue&type=script&setup=true&lang=js"

import "./production-plan-orders.vue?vue&type=style&index=0&id=b53b7d46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b53b7d46"]])

export default __exports__